module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAATtJREFUOE+tk81twkAUhGdsH5KbzxEopAKcCuAQI3yjhJSQEkwHLiHpgBvIRAolUAISKNf4iASrid4apKD8yIj4YI1X+76dN29NXPjwwnqcANZltiClplCBFT/e+vF2d921oj0wbg+m/aaAzTwT7VQAV4eirQHeX7ORkyoKHVsPAlb1t6uCIOqYbqezhQfYS9DYA8S+Adbz4QRi7NeonOIIkDkrRIwol7cG8+VfgNxgvh56BpiI3tHqqNvpLP8VcFYGP7WwKbMCVBfCi4gOxVhAQqLnO4XG3xxQuBV4d8ggJ9BrDID290JUGN0AmzJNxDCOIqzczsWmbQJ1zrU+CbGVTv2FspF+GWMCYBGSsZNOdEgubx6mkzrEcrgE3GPdW1Q0vUjmEgif6e0e7DdN/7iP2D/97890rgPb/wkyruCPpCCZ3gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/little_news.png
// module id = eFbh
// module chunks = 1